import { render, staticRenderFns } from "./suspendEmployee.vue?vue&type=template&id=587d4471&scoped=true"
import script from "./suspendEmployee.vue?vue&type=script&lang=js"
export * from "./suspendEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d4471",
  null
  
)

export default component.exports